import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { SalvarComentarioLinhaSla } from '@app/api/sla';
import { Button } from '@digital/ui';
import ListMensagem from './ListMensagem';
import TextArea from 'antd/lib/input/TextArea';

export interface PropsModalComentario {
  linhaSlaId: string;
  contemComentario: boolean;
}

const ModalComentario = (props: PropsModalComentario) => {
  const { linhaSlaId, contemComentario } = props;
  const [recarregarMensagem, setRecarregarMensagem] = useState(false);
  const [exibirModal, setExibirModal] = useState(false);
  const [iconeComentario, setIconeComentario] = useState('');
  const textAreaId = `textAreaId${linhaSlaId}`;

  useEffect(() => {
    if (contemComentario === true) {
      MudarIconeAnexo();
    }
  }, []);

  const MudarIconeAnexo = () => {
    setIconeComentario('has-comments');
  };

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  const getAll = async () => {
    setRecarregarMensagem(!recarregarMensagem);
  };

  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const Salvar = (e: any) => {
    const text = document.getElementById(textAreaId).value;
    const form = new FormData();
    form.append('linhaSlaId', linhaSlaId);
    form.append('mensagem', text);

    SalvarComentarioLinhaSla(form).then(data => {
      if (data.valid) {
        limparCampo();
        setRecarregarMensagem(!recarregarMensagem);
        MudarIconeAnexo();
      }
    });
  };

  return (
    <>
      <Tooltip title="Comentários">
        <Button
          onClick={() => {
            getAll();
            showModal();
          }}
          icon="messaging-comments"
          className={iconeComentario}
          style={{ backgroundColor: 'transparent', color: '#0D5A9A' }}
        />
      </Tooltip>
      <Modal
        title="Comentário"
        className="chat-modal"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submit" type="primary" onClick={e => Salvar(e)}>
            Enviar
          </Button>,
          <Button key="close" type="link" onClick={() => handleCancel()}>
            Fechar
          </Button>,
        ]}>
        <ListMensagem linhaSlaId={linhaSlaId} recarregarMensagem={recarregarMensagem} />
        <div className="chat-modal-message-box">
          <Form>
            <Form.Item>
              <TextArea id={textAreaId} placeholder="mensagem" autosize={{ minRows: 3, maxRows: 5 }} maxLength={300}/>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default ModalComentario;
